// GEMAAKT door tools/lokaal/allergenen-naar-widget.mjs uit de resx van het dashboard -- niet met de hand aanpassen.
// De allergenen, kruisbesmetting en voedingskenmerken (AllergyContaminationSetOptionKeys), met de namen in 13 talen. (golf 1C)
export const ALLERGEENOPTIES = [
 {
  "id": 1,
  "groep": "allergie",
  "sleutel": "ac-allergy-gluten-wheat",
  "namen": {
   "nl": "Gluten (tarwe)",
   "en": "Gluten (Wheat)",
   "da": "Gluten (hvede)",
   "de": "Gluten (Weizen)",
   "el": "Γλουτένη (Σιτάρι)",
   "es": "Gluten (trigo)",
   "fi": "Gluteeni (vehnä)",
   "fr": "Gluten (blé)",
   "it": "Glutine (frumento)",
   "no": "Gluten (hvete)",
   "pl": "Gluten (pszenica)",
   "pt": "Glúten (trigo)",
   "sv": "Gluten (vete)"
  }
 },
 {
  "id": 2,
  "groep": "allergie",
  "sleutel": "ac-allergy-gluten-rye",
  "namen": {
   "nl": "Gluten (rogge)",
   "en": "Gluten (Rye)",
   "da": "Gluten (rug)",
   "de": "Gluten (Roggen)",
   "el": "Γλουτένη (Σίκαλη)",
   "es": "Gluten (centeno)",
   "fi": "Gluteeni (ruis)",
   "fr": "Gluten (seigle)",
   "it": "Glutine (segale)",
   "no": "Gluten (rug)",
   "pl": "Gluten (żyto)",
   "pt": "Glúten (centeio)",
   "sv": "Gluten (råg)"
  }
 },
 {
  "id": 3,
  "groep": "allergie",
  "sleutel": "ac-allergy-gluten-barley",
  "namen": {
   "nl": "Gluten (gerst)",
   "en": "Gluten (Barley)",
   "da": "Gluten (byg)",
   "de": "Gluten (Gerste)",
   "el": "Γλουτένη (Κριθάρι)",
   "es": "Gluten (cebada)",
   "fi": "Gluteeni (ohra)",
   "fr": "Gluten (orge)",
   "it": "Glutine (orzo)",
   "no": "Gluten (bygg)",
   "pl": "Gluten (jęczmień)",
   "pt": "Glúten (cevada)",
   "sv": "Gluten (korn)"
  }
 },
 {
  "id": 4,
  "groep": "allergie",
  "sleutel": "ac-allergy-gluten-oats",
  "namen": {
   "nl": "Gluten (havermout)",
   "en": "Gluten (Oats)",
   "da": "Gluten (havre)",
   "de": "Gluten (Hafer)",
   "el": "Γλουτένη (Βρώμη)",
   "es": "Gluten (avena)",
   "fi": "Gluteeni (kaura)",
   "fr": "Gluten (avoine)",
   "it": "Glutine (avena)",
   "no": "Gluten (havre)",
   "pl": "Gluten (owies)",
   "pt": "Glúten (aveia)",
   "sv": "Gluten (havre)"
  }
 },
 {
  "id": 5,
  "groep": "allergie",
  "sleutel": "ac-allergy-gluten-spelt",
  "namen": {
   "nl": "Gluten (spelt)",
   "en": "Gluten (Spelt)",
   "da": "Gluten (spelt)",
   "de": "Gluten (Dinkel)",
   "el": "Γλουτένη (Ζέα)",
   "es": "Gluten (espelta)",
   "fi": "Gluteeni (speltti)",
   "fr": "Gluten (épeautre)",
   "it": "Glutine (farro)",
   "no": "Gluten (spelt)",
   "pl": "Gluten (orkisz)",
   "pt": "Glúten (espelta)",
   "sv": "Gluten (dinkel)"
  }
 },
 {
  "id": 6,
  "groep": "allergie",
  "sleutel": "ac-allergy-gluten-khorasan",
  "namen": {
   "nl": "Gluten (Khorasan-tarwe (Kamut))",
   "en": "Gluten (Khorasan wheat (Kamut))",
   "da": "Gluten (khorasanhvede (Kamut))",
   "de": "Gluten (Khorasan-Weizen (Kamut))",
   "el": "Γλουτένη (Σιτάρι Khorasan (Kamut))",
   "es": "Gluten (trigo khorasan (kamut))",
   "fi": "Gluteeni (khorasan-vehnä (Kamut))",
   "fr": "Gluten (blé de Khorasan (kamut))",
   "it": "Glutine (grano khorasan (kamut))",
   "no": "Gluten (khorasanhvete (kamut))",
   "pl": "Gluten (pszenica khorasan (kamut))",
   "pt": "Glúten (trigo khorasan (Kamut))",
   "sv": "Gluten (khorasanvete (kamut))"
  }
 },
 {
  "id": 7,
  "groep": "allergie",
  "sleutel": "ac-allergy-gluten-crustaceans",
  "namen": {
   "nl": "Gluten (schaaldieren)",
   "en": "Gluten (Crustaceans)",
   "da": "Gluten (krebsdyr)",
   "de": "Gluten (Krebstiere)",
   "el": "Γλουτένη (Οστρακοειδή)",
   "es": "Gluten (crustáceos)",
   "fi": "Gluteeni (äyriäiset)",
   "fr": "Gluten (crustacés)",
   "it": "Glutine (crostacei)",
   "no": "Gluten (skalldyr)",
   "pl": "Gluten (skorupiaki)",
   "pt": "Glúten (crustáceos)",
   "sv": "Gluten (kräftdjur)"
  }
 },
 {
  "id": 8,
  "groep": "allergie",
  "sleutel": "ac-allergy-crustaceans-shrimp",
  "namen": {
   "nl": "Kreeftachtigen (garnalen)",
   "en": "Crustaceans (Shrimp)",
   "da": "Krebsdyr (rejer)",
   "de": "Krebstiere (Garnelen)",
   "el": "Καρκινοειδή (Γαρίδες)",
   "es": "Crustáceos (gambas)",
   "fi": "Äyriäiset (katkaravut)",
   "fr": "Crustacés (crevettes)",
   "it": "Crostacei (gamberetti)",
   "no": "Skalldyr (reker)",
   "pl": "Skorupiaki (krewetki)",
   "pt": "Crustáceos (camarão)",
   "sv": "Kräftdjur (räkor)"
  }
 },
 {
  "id": 9,
  "groep": "allergie",
  "sleutel": "ac-allergy-crustaceans-crab",
  "namen": {
   "nl": "Kreeftachtigen (Krab)",
   "en": "Crustaceans (Crab)",
   "da": "Krebsdyr (krabbe)",
   "de": "Krebstiere (Krabbe)",
   "el": "Καρκινοειδή (Καβούρι)",
   "es": "Crustáceos (cangrejo)",
   "fi": "Äyriäiset (taskurapu)",
   "fr": "Crustacés (crabe)",
   "it": "Crostacei (granchio)",
   "no": "Skalldyr (krabbe)",
   "pl": "Skorupiaki (krab)",
   "pt": "Crustáceos (caranguejo)",
   "sv": "Kräftdjur (krabba)"
  }
 },
 {
  "id": 10,
  "groep": "allergie",
  "sleutel": "ac-allergy-crustaceans-cancer",
  "namen": {
   "nl": "Kreeftachtigen (Kreeft)",
   "en": "Crustaceans (Cancer)",
   "da": "Krebsdyr (hummer)",
   "de": "Krebstiere (Hummer)",
   "el": "Καρκινοειδή (Αστακός)",
   "es": "Crustáceos (bogavante)",
   "fi": "Äyriäiset (hummeri)",
   "fr": "Crustacés (homard)",
   "it": "Crostacei (astice)",
   "no": "Skalldyr (hummer)",
   "pl": "Skorupiaki (rak)",
   "pt": "Crustáceos (lavagante)",
   "sv": "Kräftdjur (hummer)"
  }
 },
 {
  "id": 11,
  "groep": "allergie",
  "sleutel": "ac-allergy-crustaceans-norway-lobster",
  "namen": {
   "nl": "Kreeftachtigen (Noorse kreeft)",
   "en": "Crustaceans (Norway lobster)",
   "da": "Krebsdyr (jomfruhummer)",
   "de": "Krebstiere (Kaisergranat)",
   "el": "Καρκινοειδή (Καραβίδα)",
   "es": "Crustáceos (cigala)",
   "fi": "Äyriäiset (keisarihummeri)",
   "fr": "Crustacés (langoustine)",
   "it": "Crostacei (scampo)",
   "no": "Skalldyr (sjøkreps)",
   "pl": "Skorupiaki (homarzec)",
   "pt": "Crustáceos (lagostim)",
   "sv": "Kräftdjur (havskräfta)"
  }
 },
 {
  "id": 12,
  "groep": "allergie",
  "sleutel": "ac-allergy-crustaceans-scampi",
  "namen": {
   "nl": "Kreeftachtigen (Scampi)",
   "en": "Crustaceans (Scampi)",
   "da": "Krebsdyr (scampi)",
   "de": "Krebstiere (Scampi)",
   "el": "Καρκινοειδή (Σκάμπι)",
   "es": "Crustáceos (langostinos)",
   "fi": "Äyriäiset (scampi)",
   "fr": "Crustacés (scampi)",
   "it": "Crostacei (scampi)",
   "no": "Skalldyr (scampi)",
   "pl": "Skorupiaki (scampi)",
   "pt": "Crustáceos (gambas)",
   "sv": "Kräftdjur (scampi)"
  }
 },
 {
  "id": 13,
  "groep": "allergie",
  "sleutel": "ac-allergy-eggs-chicken",
  "namen": {
   "nl": "Eieren (Kippenei)",
   "en": "Eggs (Chicken egg)",
   "da": "Æg (hønseæg)",
   "de": "Eier (Hühnerei)",
   "el": "Αυγά (Αυγό κότας)",
   "es": "Huevos (huevo de gallina)",
   "fi": "Kananmuna (kananmuna)",
   "fr": "Œufs (œuf de poule)",
   "it": "Uova (uovo di gallina)",
   "no": "Egg (hønseegg)",
   "pl": "Jaja (jajo kurze)",
   "pt": "Ovos (ovo de galinha)",
   "sv": "Ägg (hönsägg)"
  }
 },
 {
  "id": 14,
  "groep": "allergie",
  "sleutel": "ac-allergy-eggs-quail",
  "namen": {
   "nl": "Eieren (Kwartel-ei)",
   "en": "Eggs (Quail egg)",
   "da": "Æg (vagtelæg)",
   "de": "Eier (Wachtelei)",
   "el": "Αυγά (Αυγό ορτυκιού)",
   "es": "Huevos (huevo de codorniz)",
   "fi": "Kananmuna (viiriäisen muna)",
   "fr": "Œufs (œuf de caille)",
   "it": "Uova (uovo di quaglia)",
   "no": "Egg (vaktelegg)",
   "pl": "Jaja (jajo przepiórcze)",
   "pt": "Ovos (ovo de codorniz)",
   "sv": "Ägg (vaktelägg)"
  }
 },
 {
  "id": 15,
  "groep": "allergie",
  "sleutel": "ac-allergy-eggs-products",
  "namen": {
   "nl": "Eieren (Eierproducten)",
   "en": "Eggs (Egg products)",
   "da": "Æg (ægprodukter)",
   "de": "Eier (Eiprodukte)",
   "el": "Αυγά (Προϊόντα αυγού)",
   "es": "Huevos (productos derivados del huevo)",
   "fi": "Kananmuna (munatuotteet)",
   "fr": "Œufs (produits à base d'œuf)",
   "it": "Uova (prodotti a base di uovo)",
   "no": "Egg (eggprodukter)",
   "pl": "Jaja (produkty jajeczne)",
   "pt": "Ovos (produtos à base de ovo)",
   "sv": "Ägg (äggprodukter)"
  }
 },
 {
  "id": 16,
  "groep": "allergie",
  "sleutel": "ac-allergy-fish-all-species",
  "namen": {
   "nl": "Vissen (alle vissoorten)",
   "en": "Fish (All fish species)",
   "da": "Fisk (alle fiskearter)",
   "de": "Fische (alle Fischarten)",
   "el": "Ψάρια (Όλα τα είδη ψαριών)",
   "es": "Pescado (todas las especies)",
   "fi": "Kala (kaikki kalalajit)",
   "fr": "Poissons (toutes les espèces)",
   "it": "Pesce (tutte le specie)",
   "no": "Fisk (alle fiskearter)",
   "pl": "Ryby (wszystkie gatunki ryb)",
   "pt": "Peixe (todas as espécies)",
   "sv": "Fisk (alla fiskarter)"
  }
 },
 {
  "id": 17,
  "groep": "allergie",
  "sleutel": "ac-allergy-fish-oil",
  "namen": {
   "nl": "Vis (visolie)",
   "en": "Fish (Fish oil)",
   "da": "Fisk (fiskeolie)",
   "de": "Fisch (Fischöl)",
   "el": "Ψάρι (Ιχθυέλαιο)",
   "es": "Pescado (aceite de pescado)",
   "fi": "Kala (kalaöljy)",
   "fr": "Poisson (huile de poisson)",
   "it": "Pesce (olio di pesce)",
   "no": "Fisk (fiskeolje)",
   "pl": "Ryby (olej rybny)",
   "pt": "Peixe (óleo de peixe)",
   "sv": "Fisk (fiskolja)"
  }
 },
 {
  "id": 18,
  "groep": "allergie",
  "sleutel": "ac-allergy-fish-extracts",
  "namen": {
   "nl": "Vis (Visextracten)",
   "en": "Fish (Fish extracts)",
   "da": "Fisk (fiskeekstrakter)",
   "de": "Fisch (Fischextrakte)",
   "el": "Ψάρι (Εκχυλίσματα ψαριού)",
   "es": "Pescado (extractos de pescado)",
   "fi": "Kala (kalauutteet)",
   "fr": "Poisson (extraits de poisson)",
   "it": "Pesce (estratti di pesce)",
   "no": "Fisk (fiskeekstrakter)",
   "pl": "Ryby (ekstrakty rybne)",
   "pt": "Peixe (extratos de peixe)",
   "sv": "Fisk (fiskextrakt)"
  }
 },
 {
  "id": 19,
  "groep": "allergie",
  "sleutel": "ac-allergy-peanuts",
  "namen": {
   "nl": "Pinda's",
   "en": "Peanuts",
   "da": "Jordnødder",
   "de": "Erdnüsse",
   "el": "Αράπικα φιστίκια",
   "es": "Cacahuetes",
   "fi": "Maapähkinät",
   "fr": "Arachides",
   "it": "Arachidi",
   "no": "Peanøtter",
   "pl": "Orzeszki ziemne",
   "pt": "Amendoins",
   "sv": "Jordnötter"
  }
 },
 {
  "id": 20,
  "groep": "allergie",
  "sleutel": "ac-allergy-soy-beans",
  "namen": {
   "nl": "Soja (sojabonen)",
   "en": "Soy (Soybeans)",
   "da": "Soja (sojabønner)",
   "de": "Soja (Sojabohnen)",
   "el": "Σόγια (Σπόροι σόγιας)",
   "es": "Soja (habas de soja)",
   "fi": "Soija (soijapavut)",
   "fr": "Soja (graines de soja)",
   "it": "Soia (semi di soia)",
   "no": "Soya (soyabønner)",
   "pl": "Soja (ziarna soi)",
   "pt": "Soja (grãos de soja)",
   "sv": "Soja (sojabönor)"
  }
 },
 {
  "id": 21,
  "groep": "allergie",
  "sleutel": "ac-allergy-soy-meal",
  "namen": {
   "nl": "Soja (sojameel)",
   "en": "Soy (Soybean meal)",
   "da": "Soja (sojamel)",
   "de": "Soja (Sojamehl)",
   "el": "Σόγια (Άλευρο σόγιας)",
   "es": "Soja (harina de soja)",
   "fi": "Soija (soijajauho)",
   "fr": "Soja (farine de soja)",
   "it": "Soia (farina di soia)",
   "no": "Soya (soyamel)",
   "pl": "Soja (mączka sojowa)",
   "pt": "Soja (farinha de soja)",
   "sv": "Soja (sojamjöl)"
  }
 },
 {
  "id": 22,
  "groep": "allergie",
  "sleutel": "ac-allergy-soy-lecithin",
  "namen": {
   "nl": "Soja (Soy lecithin)",
   "en": "Soy (Soy lecithin)",
   "da": "Soja (sojalecithin)",
   "de": "Soja (Sojalecithin)",
   "el": "Σόγια (Λεκιθίνη σόγιας)",
   "es": "Soja (lecitina de soja)",
   "fi": "Soija (soijalesitiini)",
   "fr": "Soja (lécithine de soja)",
   "it": "Soia (lecitina di soia)",
   "no": "Soya (soyalecitin)",
   "pl": "Soja (lecytyna sojowa)",
   "pt": "Soja (lecitina de soja)",
   "sv": "Soja (sojalecitin)"
  }
 },
 {
  "id": 23,
  "groep": "allergie",
  "sleutel": "ac-allergy-milk",
  "namen": {
   "nl": "Melk (Melk)",
   "en": "Milk (Milk)",
   "da": "Mælk (mælk)",
   "de": "Milch (Milch)",
   "el": "Γάλα (Γάλα)",
   "es": "Leche (leche)",
   "fi": "Maito (maito)",
   "fr": "Lait (lait)",
   "it": "Latte (latte)",
   "no": "Melk (melk)",
   "pl": "Mleko (mleko)",
   "pt": "Leite (leite)",
   "sv": "Mjölk (mjölk)"
  }
 },
 {
  "id": 24,
  "groep": "allergie",
  "sleutel": "ac-allergy-milk-lactose",
  "namen": {
   "nl": "Melk (lactose)",
   "en": "Milk (Lactose)",
   "da": "Mælk (laktose)",
   "de": "Milch (Laktose)",
   "el": "Γάλα (Λακτόζη)",
   "es": "Leche (lactosa)",
   "fi": "Maito (laktoosi)",
   "fr": "Lait (lactose)",
   "it": "Latte (lattosio)",
   "no": "Melk (laktose)",
   "pl": "Mleko (laktoza)",
   "pt": "Leite (lactose)",
   "sv": "Mjölk (laktos)"
  }
 },
 {
  "id": 25,
  "groep": "allergie",
  "sleutel": "ac-allergy-milk-protein",
  "namen": {
   "nl": "Melk (melkeiwit)",
   "en": "Milk (Milk protein)",
   "da": "Mælk (mælkeprotein)",
   "de": "Milch (Milcheiweiß)",
   "el": "Γάλα (Πρωτεΐνη γάλακτος)",
   "es": "Leche (proteínas de la leche)",
   "fi": "Maito (maitoproteiini)",
   "fr": "Lait (protéines de lait)",
   "it": "Latte (proteine del latte)",
   "no": "Melk (melkeprotein)",
   "pl": "Mleko (białko mleka)",
   "pt": "Leite (proteína do leite)",
   "sv": "Mjölk (mjölkprotein)"
  }
 },
 {
  "id": 26,
  "groep": "allergie",
  "sleutel": "ac-allergy-milk-whey",
  "namen": {
   "nl": "Melk (Wei)",
   "en": "Milk (Whey)",
   "da": "Mælk (valle)",
   "de": "Milch (Molke)",
   "el": "Γάλα (Ορός γάλακτος)",
   "es": "Leche (suero de leche)",
   "fi": "Maito (hera)",
   "fr": "Lait (lactosérum)",
   "it": "Latte (siero di latte)",
   "no": "Melk (myse)",
   "pl": "Mleko (serwatka)",
   "pt": "Leite (soro de leite)",
   "sv": "Mjölk (vassle)"
  }
 },
 {
  "id": 27,
  "groep": "allergie",
  "sleutel": "ac-allergy-nuts-almonds",
  "namen": {
   "nl": "Noten (Amandelen)",
   "en": "Nuts (Almonds)",
   "da": "Nødder (mandler)",
   "de": "Nüsse (Mandeln)",
   "el": "Ξηροί καρποί (Αμύγδαλα)",
   "es": "Frutos de cáscara (almendras)",
   "fi": "Pähkinät (mantelit)",
   "fr": "Fruits à coque (amandes)",
   "it": "Frutta a guscio (mandorle)",
   "no": "Nøtter (mandler)",
   "pl": "Orzechy (migdały)",
   "pt": "Frutos de casca rija (amêndoas)",
   "sv": "Nötter (mandlar)"
  }
 },
 {
  "id": 28,
  "groep": "allergie",
  "sleutel": "ac-allergy-nuts-hazelnuts",
  "namen": {
   "nl": "Noten (Hazelnoten)",
   "en": "Nuts (Hazelnuts)",
   "da": "Nødder (hasselnødder)",
   "de": "Nüsse (Haselnüsse)",
   "el": "Ξηροί καρποί (Φουντούκια)",
   "es": "Frutos de cáscara (avellanas)",
   "fi": "Pähkinät (hasselpähkinät)",
   "fr": "Fruits à coque (noisettes)",
   "it": "Frutta a guscio (nocciole)",
   "no": "Nøtter (hasselnøtter)",
   "pl": "Orzechy (orzechy laskowe)",
   "pt": "Frutos de casca rija (avelãs)",
   "sv": "Nötter (hasselnötter)"
  }
 },
 {
  "id": 29,
  "groep": "allergie",
  "sleutel": "ac-allergy-nuts-walnuts",
  "namen": {
   "nl": "Noten (walnoten)",
   "en": "Nuts (Walnuts)",
   "da": "Nødder (valnødder)",
   "de": "Nüsse (Walnüsse)",
   "el": "Ξηροί καρποί (Καρύδια)",
   "es": "Frutos de cáscara (nueces)",
   "fi": "Pähkinät (saksanpähkinät)",
   "fr": "Fruits à coque (noix)",
   "it": "Frutta a guscio (noci)",
   "no": "Nøtter (valnøtter)",
   "pl": "Orzechy (orzechy włoskie)",
   "pt": "Frutos de casca rija (nozes)",
   "sv": "Nötter (valnötter)"
  }
 },
 {
  "id": 30,
  "groep": "allergie",
  "sleutel": "ac-allergy-nuts-cashews",
  "namen": {
   "nl": "Noten (Cashewnoten)",
   "en": "Nuts (Cashews)",
   "da": "Nødder (cashewnødder)",
   "de": "Nüsse (Cashewnüsse)",
   "el": "Ξηροί καρποί (Κάσιους)",
   "es": "Frutos de cáscara (anacardos)",
   "fi": "Pähkinät (cashewpähkinät)",
   "fr": "Fruits à coque (noix de cajou)",
   "it": "Frutta a guscio (anacardi)",
   "no": "Nøtter (cashewnøtter)",
   "pl": "Orzechy (nerkowce)",
   "pt": "Frutos de casca rija (cajus)",
   "sv": "Nötter (cashewnötter)"
  }
 },
 {
  "id": 31,
  "groep": "allergie",
  "sleutel": "ac-allergy-nuts-pecans",
  "namen": {
   "nl": "Noten (pecannoten)",
   "en": "Nuts (Pecans)",
   "da": "Nødder (pekannødder)",
   "de": "Nüsse (Pekannüsse)",
   "el": "Ξηροί καρποί (Πεκάν)",
   "es": "Frutos de cáscara (nueces pecanas)",
   "fi": "Pähkinät (pekaanipähkinät)",
   "fr": "Fruits à coque (noix de pécan)",
   "it": "Frutta a guscio (noci pecan)",
   "no": "Nøtter (pekannøtter)",
   "pl": "Orzechy (orzechy pekan)",
   "pt": "Frutos de casca rija (nozes-pecã)",
   "sv": "Nötter (pekannötter)"
  }
 },
 {
  "id": 32,
  "groep": "allergie",
  "sleutel": "ac-allergy-nuts-brazil",
  "namen": {
   "nl": "Noten (Braziliaanse noten)",
   "en": "Nuts (Brazil nuts)",
   "da": "Nødder (paranødder)",
   "de": "Nüsse (Paranüsse)",
   "el": "Ξηροί καρποί (Καρύδια Βραζιλίας)",
   "es": "Frutos de cáscara (nueces de Brasil)",
   "fi": "Pähkinät (parapähkinät)",
   "fr": "Fruits à coque (noix du Brésil)",
   "it": "Frutta a guscio (noci del Brasile)",
   "no": "Nøtter (paranøtter)",
   "pl": "Orzechy (orzechy brazylijskie)",
   "pt": "Frutos de casca rija (castanhas-do-brasil)",
   "sv": "Nötter (paranötter)"
  }
 },
 {
  "id": 33,
  "groep": "allergie",
  "sleutel": "ac-allergy-nuts-pistachios",
  "namen": {
   "nl": "Noten (pistachenoten)",
   "en": "Nuts (Pistachios)",
   "da": "Nødder (pistacienødder)",
   "de": "Nüsse (Pistazien)",
   "el": "Ξηροί καρποί (Φιστίκια Αιγίνης)",
   "es": "Frutos de cáscara (pistachos)",
   "fi": "Pähkinät (pistaasipähkinät)",
   "fr": "Fruits à coque (pistaches)",
   "it": "Frutta a guscio (pistacchi)",
   "no": "Nøtter (pistasjnøtter)",
   "pl": "Orzechy (pistacje)",
   "pt": "Frutos de casca rija (pistácios)",
   "sv": "Nötter (pistaschnötter)"
  }
 },
 {
  "id": 34,
  "groep": "allergie",
  "sleutel": "ac-allergy-nuts-macadamia",
  "namen": {
   "nl": "Noten (Macadamianoten)",
   "en": "Nuts (Macadamia nuts)",
   "da": "Nødder (macadamianødder)",
   "de": "Nüsse (Macadamianüsse)",
   "el": "Ξηροί καρποί (Μακαντάμια)",
   "es": "Frutos de cáscara (nueces de macadamia)",
   "fi": "Pähkinät (macadamiapähkinät)",
   "fr": "Fruits à coque (noix de macadamia)",
   "it": "Frutta a guscio (noci di macadamia)",
   "no": "Nøtter (macadamianøtter)",
   "pl": "Orzechy (orzechy makadamia)",
   "pt": "Frutos de casca rija (nozes de macadâmia)",
   "sv": "Nötter (macadamianötter)"
  }
 },
 {
  "id": 35,
  "groep": "allergie",
  "sleutel": "ac-allergy-celery",
  "namen": {
   "nl": "Selderij",
   "en": "Celery",
   "da": "Selleri",
   "de": "Sellerie",
   "el": "Σέλινο",
   "es": "Apio",
   "fi": "Selleri",
   "fr": "Céleri",
   "it": "Sedano",
   "no": "Selleri",
   "pl": "Seler",
   "pt": "Aipo",
   "sv": "Selleri"
  }
 },
 {
  "id": 36,
  "groep": "allergie",
  "sleutel": "ac-allergy-mustard",
  "namen": {
   "nl": "Mosterd",
   "en": "Mustard",
   "da": "Sennep",
   "de": "Senf",
   "el": "Μουστάρδα",
   "es": "Mostaza",
   "fi": "Sinappi",
   "fr": "Moutarde",
   "it": "Senape",
   "no": "Sennep",
   "pl": "Gorczyca",
   "pt": "Mostarda",
   "sv": "Senap"
  }
 },
 {
  "id": 37,
  "groep": "allergie",
  "sleutel": "ac-allergy-sesame-seeds",
  "namen": {
   "nl": "Sesamzaadjes",
   "en": "Sesame seeds",
   "da": "Sesamfrø",
   "de": "Sesamsamen",
   "el": "Σουσάμι",
   "es": "Semillas de sésamo",
   "fi": "Seesaminsiemenet",
   "fr": "Graines de sésame",
   "it": "Semi di sesamo",
   "no": "Sesamfrø",
   "pl": "Nasiona sezamu",
   "pt": "Sementes de sésamo",
   "sv": "Sesamfrön"
  }
 },
 {
  "id": 38,
  "groep": "allergie",
  "sleutel": "ac-allergy-sulphites",
  "namen": {
   "nl": "Sulfieten (>10 mg/kg)",
   "en": "Sulphites (>10 mg/kg)",
   "da": "Sulfitter (>10 mg/kg)",
   "de": "Sulfite (>10 mg/kg)",
   "el": "Θειώδη (>10 mg/kg)",
   "es": "Sulfitos (>10 mg/kg)",
   "fi": "Sulfiitit (>10 mg/kg)",
   "fr": "Sulfites (>10 mg/kg)",
   "it": "Solfiti (>10 mg/kg)",
   "no": "Sulfitter (>10 mg/kg)",
   "pl": "Siarczyny (>10 mg/kg)",
   "pt": "Sulfitos (>10 mg/kg)",
   "sv": "Sulfiter (>10 mg/kg)"
  }
 },
 {
  "id": 39,
  "groep": "allergie",
  "sleutel": "ac-allergy-lupin",
  "namen": {
   "nl": "Lupin",
   "en": "Lupin",
   "da": "Lupin",
   "de": "Lupine",
   "el": "Λούπινο",
   "es": "Altramuces",
   "fi": "Lupiini",
   "fr": "Lupin",
   "it": "Lupini",
   "no": "Lupin",
   "pl": "Łubin",
   "pt": "Tremoço",
   "sv": "Lupin"
  }
 },
 {
  "id": 40,
  "groep": "allergie",
  "sleutel": "ac-allergy-molluscs-mussels",
  "namen": {
   "nl": "Weekdieren (mosselen)",
   "en": "Molluscs (Mussels)",
   "da": "Bløddyr (muslinger)",
   "de": "Weichtiere (Miesmuscheln)",
   "el": "Μαλάκια (Μύδια)",
   "es": "Moluscos (mejillones)",
   "fi": "Nilviäiset (simpukat)",
   "fr": "Mollusques (moules)",
   "it": "Molluschi (cozze)",
   "no": "Bløtdyr (blåskjell)",
   "pl": "Mięczaki (małże)",
   "pt": "Moluscos (mexilhões)",
   "sv": "Blötdjur (musslor)"
  }
 },
 {
  "id": 41,
  "groep": "allergie",
  "sleutel": "ac-allergy-molluscs-oysters",
  "namen": {
   "nl": "Weekdieren (oesters)",
   "en": "Molluscs (Oysters)",
   "da": "Bløddyr (østers)",
   "de": "Weichtiere (Austern)",
   "el": "Μαλάκια (Στρείδια)",
   "es": "Moluscos (ostras)",
   "fi": "Nilviäiset (osterit)",
   "fr": "Mollusques (huîtres)",
   "it": "Molluschi (ostriche)",
   "no": "Bløtdyr (østers)",
   "pl": "Mięczaki (ostrygi)",
   "pt": "Moluscos (ostras)",
   "sv": "Blötdjur (ostron)"
  }
 },
 {
  "id": 42,
  "groep": "allergie",
  "sleutel": "ac-allergy-molluscs-squid",
  "namen": {
   "nl": "Weekdieren (inktvis)",
   "en": "Molluscs (Squid)",
   "da": "Bløddyr (tiarmet blæksprutte)",
   "de": "Weichtiere (Tintenfisch)",
   "el": "Μαλάκια (Καλαμάρι)",
   "es": "Moluscos (calamar)",
   "fi": "Nilviäiset (kalmari)",
   "fr": "Mollusques (calmar)",
   "it": "Molluschi (calamaro)",
   "no": "Bløtdyr (akkar)",
   "pl": "Mięczaki (kałamarnica)",
   "pt": "Moluscos (lulas)",
   "sv": "Blötdjur (tioarmad bläckfisk)"
  }
 },
 {
  "id": 43,
  "groep": "allergie",
  "sleutel": "ac-allergy-molluscs-octopus",
  "namen": {
   "nl": "Weekdieren (octopus)",
   "en": "Molluscs (Octopus)",
   "da": "Bløddyr (blæksprutte)",
   "de": "Weichtiere (Oktopus)",
   "el": "Μαλάκια (Χταπόδι)",
   "es": "Moluscos (pulpo)",
   "fi": "Nilviäiset (mustekala)",
   "fr": "Mollusques (poulpe)",
   "it": "Molluschi (polpo)",
   "no": "Bløtdyr (blekksprut)",
   "pl": "Mięczaki (ośmiornica)",
   "pt": "Moluscos (polvo)",
   "sv": "Blötdjur (bläckfisk)"
  }
 },
 {
  "id": 44,
  "groep": "allergie",
  "sleutel": "ac-allergy-molluscs-snails",
  "namen": {
   "nl": "Weekdieren (Slakken)",
   "en": "Molluscs (Snails)",
   "da": "Bløddyr (snegle)",
   "de": "Weichtiere (Schnecken)",
   "el": "Μαλάκια (Σαλιγκάρια)",
   "es": "Moluscos (caracoles)",
   "fi": "Nilviäiset (etanat)",
   "fr": "Mollusques (escargots)",
   "it": "Molluschi (lumache)",
   "no": "Bløtdyr (snegler)",
   "pl": "Mięczaki (ślimaki)",
   "pt": "Moluscos (caracóis)",
   "sv": "Blötdjur (snäckor)"
  }
 },
 {
  "id": 1001,
  "groep": "kruis",
  "sleutel": "ac-cross-gluten",
  "namen": {
   "nl": "Kan sporen van gluten bevatten",
   "en": "May contain traces of gluten",
   "da": "Kan indeholde spor af gluten",
   "de": "Kann Spuren von Gluten enthalten",
   "el": "Μπορεί να περιέχει ίχνη γλουτένης",
   "es": "Puede contener trazas de gluten",
   "fi": "Voi sisältää pieniä määriä gluteenia",
   "fr": "Peut contenir des traces de gluten",
   "it": "Può contenere tracce di glutine",
   "no": "Kan inneholde spor av gluten",
   "pl": "Może zawierać śladowe ilości glutenu",
   "pt": "Pode conter vestígios de glúten",
   "sv": "Kan innehålla spår av gluten"
  }
 },
 {
  "id": 1002,
  "groep": "kruis",
  "sleutel": "ac-cross-milk",
  "namen": {
   "nl": "Kan sporen van melk bevatten",
   "en": "May contain traces of milk",
   "da": "Kan indeholde spor af mælk",
   "de": "Kann Spuren von Milch enthalten",
   "el": "Μπορεί να περιέχει ίχνη γάλακτος",
   "es": "Puede contener trazas de leche",
   "fi": "Voi sisältää pieniä määriä maitoa",
   "fr": "Peut contenir des traces de lait",
   "it": "Può contenere tracce di latte",
   "no": "Kan inneholde spor av melk",
   "pl": "Może zawierać śladowe ilości mleka",
   "pt": "Pode conter vestígios de leite",
   "sv": "Kan innehålla spår av mjölk"
  }
 },
 {
  "id": 1003,
  "groep": "kruis",
  "sleutel": "ac-cross-egg",
  "namen": {
   "nl": "Kan sporen van ei bevatten",
   "en": "May contain traces of egg",
   "da": "Kan indeholde spor af æg",
   "de": "Kann Spuren von Ei enthalten",
   "el": "Μπορεί να περιέχει ίχνη αυγού",
   "es": "Puede contener trazas de huevo",
   "fi": "Voi sisältää pieniä määriä kananmunaa",
   "fr": "Peut contenir des traces d'œuf",
   "it": "Può contenere tracce di uovo",
   "no": "Kan inneholde spor av egg",
   "pl": "Może zawierać śladowe ilości jaj",
   "pt": "Pode conter vestígios de ovo",
   "sv": "Kan innehålla spår av ägg"
  }
 },
 {
  "id": 1004,
  "groep": "kruis",
  "sleutel": "ac-cross-peanuts",
  "namen": {
   "nl": "Kan sporen van pinda's bevatten",
   "en": "May contain traces of peanuts",
   "da": "Kan indeholde spor af jordnødder",
   "de": "Kann Spuren von Erdnüssen enthalten",
   "el": "Μπορεί να περιέχει ίχνη αράπικων φιστικιών",
   "es": "Puede contener trazas de cacahuetes",
   "fi": "Voi sisältää pieniä määriä maapähkinää",
   "fr": "Peut contenir des traces d'arachides",
   "it": "Può contenere tracce di arachidi",
   "no": "Kan inneholde spor av peanøtter",
   "pl": "Może zawierać śladowe ilości orzeszków ziemnych",
   "pt": "Pode conter vestígios de amendoins",
   "sv": "Kan innehålla spår av jordnötter"
  }
 },
 {
  "id": 1005,
  "groep": "kruis",
  "sleutel": "ac-cross-nuts",
  "namen": {
   "nl": "Kan sporen van noten bevatten",
   "en": "May contain traces of nuts",
   "da": "Kan indeholde spor af nødder",
   "de": "Kann Spuren von Nüssen enthalten",
   "el": "Μπορεί να περιέχει ίχνη ξηρών καρπών",
   "es": "Puede contener trazas de frutos de cáscara",
   "fi": "Voi sisältää pieniä määriä pähkinöitä",
   "fr": "Peut contenir des traces de fruits à coque",
   "it": "Può contenere tracce di frutta a guscio",
   "no": "Kan inneholde spor av nøtter",
   "pl": "Może zawierać śladowe ilości orzechów",
   "pt": "Pode conter vestígios de frutos de casca rija",
   "sv": "Kan innehålla spår av nötter"
  }
 },
 {
  "id": 1006,
  "groep": "kruis",
  "sleutel": "ac-cross-soy",
  "namen": {
   "nl": "Kan sporen van soja bevatten",
   "en": "May contain traces of soy",
   "da": "Kan indeholde spor af soja",
   "de": "Kann Spuren von Soja enthalten",
   "el": "Μπορεί να περιέχει ίχνη σόγιας",
   "es": "Puede contener trazas de soja",
   "fi": "Voi sisältää pieniä määriä soijaa",
   "fr": "Peut contenir des traces de soja",
   "it": "Può contenere tracce di soia",
   "no": "Kan inneholde spor av soya",
   "pl": "Może zawierać śladowe ilości soi",
   "pt": "Pode conter vestígios de soja",
   "sv": "Kan innehålla spår av soja"
  }
 },
 {
  "id": 1007,
  "groep": "kruis",
  "sleutel": "ac-cross-sesame",
  "namen": {
   "nl": "Kan sporen van sesam bevatten",
   "en": "May contain traces of sesame",
   "da": "Kan indeholde spor af sesam",
   "de": "Kann Spuren von Sesam enthalten",
   "el": "Μπορεί να περιέχει ίχνη σουσαμιού",
   "es": "Puede contener trazas de sésamo",
   "fi": "Voi sisältää pieniä määriä seesamia",
   "fr": "Peut contenir des traces de sésame",
   "it": "Può contenere tracce di sesamo",
   "no": "Kan inneholde spor av sesam",
   "pl": "Może zawierać śladowe ilości sezamu",
   "pt": "Pode conter vestígios de sésamo",
   "sv": "Kan innehålla spår av sesam"
  }
 },
 {
  "id": 1008,
  "groep": "kruis",
  "sleutel": "ac-cross-mustard",
  "namen": {
   "nl": "Kan sporen van mosterd bevatten",
   "en": "May contain traces of mustard",
   "da": "Kan indeholde spor af sennep",
   "de": "Kann Spuren von Senf enthalten",
   "el": "Μπορεί να περιέχει ίχνη μουστάρδας",
   "es": "Puede contener trazas de mostaza",
   "fi": "Voi sisältää pieniä määriä sinappia",
   "fr": "Peut contenir des traces de moutarde",
   "it": "Può contenere tracce di senape",
   "no": "Kan inneholde spor av sennep",
   "pl": "Może zawierać śladowe ilości gorczycy",
   "pt": "Pode conter vestígios de mostarda",
   "sv": "Kan innehålla spår av senap"
  }
 },
 {
  "id": 1009,
  "groep": "kruis",
  "sleutel": "ac-cross-celery",
  "namen": {
   "nl": "Kan sporen van selderij bevatten",
   "en": "May contain traces of celery",
   "da": "Kan indeholde spor af selleri",
   "de": "Kann Spuren von Sellerie enthalten",
   "el": "Μπορεί να περιέχει ίχνη σέλινου",
   "es": "Puede contener trazas de apio",
   "fi": "Voi sisältää pieniä määriä selleriä",
   "fr": "Peut contenir des traces de céleri",
   "it": "Può contenere tracce di sedano",
   "no": "Kan inneholde spor av selleri",
   "pl": "Może zawierać śladowe ilości selera",
   "pt": "Pode conter vestígios de aipo",
   "sv": "Kan innehålla spår av selleri"
  }
 },
 {
  "id": 1010,
  "groep": "kruis",
  "sleutel": "ac-cross-fish",
  "namen": {
   "nl": "Kan sporen van vis bevatten",
   "en": "May contain traces of fish",
   "da": "Kan indeholde spor af fisk",
   "de": "Kann Spuren von Fisch enthalten",
   "el": "Μπορεί να περιέχει ίχνη ψαριού",
   "es": "Puede contener trazas de pescado",
   "fi": "Voi sisältää pieniä määriä kalaa",
   "fr": "Peut contenir des traces de poisson",
   "it": "Può contenere tracce di pesce",
   "no": "Kan inneholde spor av fisk",
   "pl": "Może zawierać śladowe ilości ryb",
   "pt": "Pode conter vestígios de peixe",
   "sv": "Kan innehålla spår av fisk"
  }
 },
 {
  "id": 1011,
  "groep": "kruis",
  "sleutel": "ac-cross-crustaceans",
  "namen": {
   "nl": "Kan sporen van kreeftachtigen bevatten",
   "en": "May contain traces of crustaceans",
   "da": "Kan indeholde spor af krebsdyr",
   "de": "Kann Spuren von Krebstieren enthalten",
   "el": "Μπορεί να περιέχει ίχνη καρκινοειδών",
   "es": "Puede contener trazas de crustáceos",
   "fi": "Voi sisältää pieniä määriä äyriäisiä",
   "fr": "Peut contenir des traces de crustacés",
   "it": "Può contenere tracce di crostacei",
   "no": "Kan inneholde spor av skalldyr",
   "pl": "Może zawierać śladowe ilości skorupiaków",
   "pt": "Pode conter vestígios de crustáceos",
   "sv": "Kan innehålla spår av kräftdjur"
  }
 },
 {
  "id": 1012,
  "groep": "kruis",
  "sleutel": "ac-cross-molluscs",
  "namen": {
   "nl": "Kan sporen van weekdieren bevatten",
   "en": "May contain traces of molluscs",
   "da": "Kan indeholde spor af bløddyr",
   "de": "Kann Spuren von Weichtieren enthalten",
   "el": "Μπορεί να περιέχει ίχνη μαλακίων",
   "es": "Puede contener trazas de moluscos",
   "fi": "Voi sisältää pieniä määriä nilviäisiä",
   "fr": "Peut contenir des traces de mollusques",
   "it": "Può contenere tracce di molluschi",
   "no": "Kan inneholde spor av bløtdyr",
   "pl": "Może zawierać śladowe ilości mięczaków",
   "pt": "Pode conter vestígios de moluscos",
   "sv": "Kan innehålla spår av blötdjur"
  }
 },
 {
  "id": 1013,
  "groep": "kruis",
  "sleutel": "ac-cross-sulphites",
  "namen": {
   "nl": "Kan sporen van sulfieten bevatten",
   "en": "May contain traces of sulphites",
   "da": "Kan indeholde spor af sulfitter",
   "de": "Kann Spuren von Sulfiten enthalten",
   "el": "Μπορεί να περιέχει ίχνη θειωδών",
   "es": "Puede contener trazas de sulfitos",
   "fi": "Voi sisältää pieniä määriä sulfiitteja",
   "fr": "Peut contenir des traces de sulfites",
   "it": "Può contenere tracce di solfiti",
   "no": "Kan inneholde spor av sulfitter",
   "pl": "Może zawierać śladowe ilości siarczynów",
   "pt": "Pode conter vestígios de sulfitos",
   "sv": "Kan innehålla spår av sulfiter"
  }
 },
 {
  "id": 1014,
  "groep": "kruis",
  "sleutel": "ac-cross-lupin",
  "namen": {
   "nl": "Kan sporen van lupine bevatten",
   "en": "May contain traces of lupin",
   "da": "Kan indeholde spor af lupin",
   "de": "Kann Spuren von Lupine enthalten",
   "el": "Μπορεί να περιέχει ίχνη λούπινου",
   "es": "Puede contener trazas de altramuces",
   "fi": "Voi sisältää pieniä määriä lupiinia",
   "fr": "Peut contenir des traces de lupin",
   "it": "Può contenere tracce di lupini",
   "no": "Kan inneholde spor av lupin",
   "pl": "Może zawierać śladowe ilości łubinu",
   "pt": "Pode conter vestígios de tremoço",
   "sv": "Kan innehålla spår av lupin"
  }
 },
 {
  "id": 2001,
  "groep": "voeding",
  "sleutel": "ac-nutritional-vegetarian",
  "namen": {
   "nl": "Vegetarisch",
   "en": "Vegetarian",
   "da": "Vegetarisk",
   "de": "Vegetarisch",
   "el": "Χορτοφαγικό",
   "es": "Vegetariano",
   "fi": "Kasvis",
   "fr": "Végétarien",
   "it": "Vegetariano",
   "no": "Vegetarisk",
   "pl": "Wegetariańskie",
   "pt": "Vegetariano",
   "sv": "Vegetarisk"
  }
 },
 {
  "id": 2002,
  "groep": "voeding",
  "sleutel": "ac-nutritional-vegan",
  "namen": {
   "nl": "Veganistisch",
   "en": "Vegan",
   "da": "Vegansk",
   "de": "Vegan",
   "el": "Vegan",
   "es": "Vegano",
   "fi": "Vegaaninen",
   "fr": "Végétalien",
   "it": "Vegano",
   "no": "Vegansk",
   "pl": "Wegańskie",
   "pt": "Vegano",
   "sv": "Vegansk"
  }
 },
 {
  "id": 2003,
  "groep": "voeding",
  "sleutel": "ac-nutritional-pescatarian",
  "namen": {
   "nl": "Pescotariërs",
   "en": "Pescatarian",
   "da": "Pescetar",
   "de": "Pescetarier",
   "el": "Πεσκετεριανό",
   "es": "Pescetariano",
   "fi": "Pescovegetaarinen",
   "fr": "Pescétarien",
   "it": "Pescetariano",
   "no": "Pescetarianer",
   "pl": "Peskatariańskie",
   "pt": "Pescetariano",
   "sv": "Pescetarian"
  }
 },
 {
  "id": 2004,
  "groep": "voeding",
  "sleutel": "ac-nutritional-flexitarian",
  "namen": {
   "nl": "Flexitariër",
   "en": "Flexitarian",
   "da": "Flexitar",
   "de": "Flexitarier",
   "el": "Χορτοφαγικό κατά προτίμηση (flexitarian)",
   "es": "Flexitariano",
   "fi": "Fleksitaristi",
   "fr": "Flexitarien",
   "it": "Flexitariano",
   "no": "Fleksitarianer",
   "pl": "Fleksitariańskie",
   "pt": "Flexitariano",
   "sv": "Flexitarian"
  }
 },
 {
  "id": 2005,
  "groep": "voeding",
  "sleutel": "ac-nutritional-gluten-free",
  "namen": {
   "nl": "Glutenvrij",
   "en": "Gluten-free",
   "da": "Glutenfri",
   "de": "Glutenfrei",
   "el": "Χωρίς γλουτένη",
   "es": "Sin gluten",
   "fi": "Gluteeniton",
   "fr": "Sans gluten",
   "it": "Senza glutine",
   "no": "Glutenfri",
   "pl": "Bezglutenowe",
   "pt": "Sem glúten",
   "sv": "Glutenfri"
  }
 },
 {
  "id": 2006,
  "groep": "voeding",
  "sleutel": "ac-nutritional-lactose-free",
  "namen": {
   "nl": "Lactosevrij",
   "en": "Lactose-free",
   "da": "Laktosefri",
   "de": "Laktosefrei",
   "el": "Χωρίς λακτόζη",
   "es": "Sin lactosa",
   "fi": "Laktoositon",
   "fr": "Sans lactose",
   "it": "Senza lattosio",
   "no": "Laktosefri",
   "pl": "Bez laktozy",
   "pt": "Sem lactose",
   "sv": "Laktosfri"
  }
 },
 {
  "id": 2007,
  "groep": "voeding",
  "sleutel": "ac-nutritional-milk-free",
  "namen": {
   "nl": "Melkvrij",
   "en": "Milk-free",
   "da": "Mælkefri",
   "de": "Milchfrei",
   "el": "Χωρίς γάλα",
   "es": "Sin leche",
   "fi": "Maidoton",
   "fr": "Sans lait",
   "it": "Senza latte",
   "no": "Melkefri",
   "pl": "Bez mleka",
   "pt": "Sem leite",
   "sv": "Mjölkfri"
  }
 },
 {
  "id": 2008,
  "groep": "voeding",
  "sleutel": "ac-nutritional-egg-free",
  "namen": {
   "nl": "Eivrij",
   "en": "Egg-free",
   "da": "Ægfri",
   "de": "Eifrei",
   "el": "Χωρίς αυγά",
   "es": "Sin huevo",
   "fi": "Kananmunaton",
   "fr": "Sans œuf",
   "it": "Senza uova",
   "no": "Eggfri",
   "pl": "Bez jaj",
   "pt": "Sem ovo",
   "sv": "Äggfri"
  }
 },
 {
  "id": 2009,
  "groep": "voeding",
  "sleutel": "ac-nutritional-nut-free",
  "namen": {
   "nl": "Notenvrij",
   "en": "Nut-free",
   "da": "Nøddefri",
   "de": "Nussfrei",
   "el": "Χωρίς ξηρούς καρπούς",
   "es": "Sin frutos de cáscara",
   "fi": "Pähkinätön",
   "fr": "Sans fruits à coque",
   "it": "Senza frutta a guscio",
   "no": "Nøttefri",
   "pl": "Bez orzechów",
   "pt": "Sem frutos de casca rija",
   "sv": "Nötfri"
  }
 },
 {
  "id": 2010,
  "groep": "voeding",
  "sleutel": "ac-nutritional-peanut-free",
  "namen": {
   "nl": "Pinda-vrij",
   "en": "Peanut-free",
   "da": "Jordnøddefri",
   "de": "Erdnussfrei",
   "el": "Χωρίς αράπικα φιστίκια",
   "es": "Sin cacahuetes",
   "fi": "Maapähkinätön",
   "fr": "Sans arachides",
   "it": "Senza arachidi",
   "no": "Peanøttfri",
   "pl": "Bez orzeszków ziemnych",
   "pt": "Sem amendoim",
   "sv": "Jordnötsfri"
  }
 },
 {
  "id": 2011,
  "groep": "voeding",
  "sleutel": "ac-nutritional-soy-free",
  "namen": {
   "nl": "Sojavrij",
   "en": "Soy-free",
   "da": "Sojafri",
   "de": "Sojafrei",
   "el": "Χωρίς σόγια",
   "es": "Sin soja",
   "fi": "Soijaton",
   "fr": "Sans soja",
   "it": "Senza soia",
   "no": "Soyafri",
   "pl": "Bez soi",
   "pt": "Sem soja",
   "sv": "Sojafri"
  }
 },
 {
  "id": 2012,
  "groep": "voeding",
  "sleutel": "ac-nutritional-sugar-free",
  "namen": {
   "nl": "Suikervrij",
   "en": "Sugar-free",
   "da": "Sukkerfri",
   "de": "Zuckerfrei",
   "el": "Χωρίς ζάχαρη",
   "es": "Sin azúcar",
   "fi": "Sokeriton",
   "fr": "Sans sucre",
   "it": "Senza zucchero",
   "no": "Sukkerfri",
   "pl": "Bez cukru",
   "pt": "Sem açúcar",
   "sv": "Sockerfri"
  }
 },
 {
  "id": 2013,
  "groep": "voeding",
  "sleutel": "ac-nutritional-low-sugar",
  "namen": {
   "nl": "Laag suikergehalte",
   "en": "Low sugar content",
   "da": "Lavt sukkerindhold",
   "de": "Zuckerarm",
   "el": "Χαμηλή περιεκτικότητα σε ζάχαρη",
   "es": "Bajo en azúcar",
   "fi": "Vähäsokerinen",
   "fr": "Pauvre en sucre",
   "it": "Povero di zuccheri",
   "no": "Lavt sukkerinnhold",
   "pl": "Niska zawartość cukru",
   "pt": "Baixo teor de açúcar",
   "sv": "Låg sockerhalt"
  }
 },
 {
  "id": 2014,
  "groep": "voeding",
  "sleutel": "ac-nutritional-low-carb",
  "namen": {
   "nl": "Weinig koolhydraten",
   "en": "Low carb",
   "da": "Få kulhydrater",
   "de": "Kohlenhydratarm",
   "el": "Χαμηλοί υδατάνθρακες",
   "es": "Bajo en hidratos de carbono",
   "fi": "Vähähiilihydraattinen",
   "fr": "Pauvre en glucides",
   "it": "Povero di carboidrati",
   "no": "Lite karbohydrater",
   "pl": "Niskowęglowodanowe",
   "pt": "Baixo em hidratos de carbono",
   "sv": "Få kolhydrater"
  }
 },
 {
  "id": 2015,
  "groep": "voeding",
  "sleutel": "ac-nutritional-high-protein",
  "namen": {
   "nl": "Hoog eiwitgehalte",
   "en": "High protein",
   "da": "Højt proteinindhold",
   "de": "Hoher Proteingehalt",
   "el": "Υψηλή περιεκτικότητα σε πρωτεΐνη",
   "es": "Rico en proteínas",
   "fi": "Runsasproteiininen",
   "fr": "Riche en protéines",
   "it": "Ricco di proteine",
   "no": "Høyt proteininnhold",
   "pl": "Wysoka zawartość białka",
   "pt": "Rico em proteína",
   "sv": "Hög proteinhalt"
  }
 },
 {
  "id": 2016,
  "groep": "voeding",
  "sleutel": "ac-nutritional-low-fat",
  "namen": {
   "nl": "Vetarm",
   "en": "Low in fat",
   "da": "Fedtfattig",
   "de": "Fettarm",
   "el": "Χαμηλά λιπαρά",
   "es": "Bajo en grasas",
   "fi": "Vähärasvainen",
   "fr": "Pauvre en matières grasses",
   "it": "Povero di grassi",
   "no": "Fettfattig",
   "pl": "Niskotłuszczowe",
   "pt": "Baixo teor de gordura",
   "sv": "Fettsnål"
  }
 },
 {
  "id": 2017,
  "groep": "voeding",
  "sleutel": "ac-nutritional-low-salt",
  "namen": {
   "nl": "Laag in zout",
   "en": "Low in salt",
   "da": "Lavt saltindhold",
   "de": "Salzarm",
   "el": "Χαμηλό σε αλάτι",
   "es": "Bajo en sal",
   "fi": "Vähäsuolainen",
   "fr": "Pauvre en sel",
   "it": "Povero di sale",
   "no": "Lite salt",
   "pl": "Niska zawartość soli",
   "pt": "Baixo teor de sal",
   "sv": "Låg salthalt"
  }
 },
 {
  "id": 2018,
  "groep": "voeding",
  "sleutel": "ac-nutritional-whole-grain",
  "namen": {
   "nl": "Volkoren",
   "en": "Whole grain",
   "da": "Fuldkorn",
   "de": "Vollkorn",
   "el": "Ολικής άλεσης",
   "es": "Integral",
   "fi": "Täysjyvä",
   "fr": "Complet",
   "it": "Integrale",
   "no": "Fullkorn",
   "pl": "Pełnoziarniste",
   "pt": "Integral",
   "sv": "Fullkorn"
  }
 },
 {
  "id": 2019,
  "groep": "voeding",
  "sleutel": "ac-nutritional-halal",
  "namen": {
   "nl": "Halal",
   "en": "Halal",
   "da": "Halal",
   "de": "Halal",
   "el": "Halal",
   "es": "Halal",
   "fi": "Halal",
   "fr": "Halal",
   "it": "Halal",
   "no": "Halal",
   "pl": "Halal",
   "pt": "Halal",
   "sv": "Halal"
  }
 },
 {
  "id": 2020,
  "groep": "voeding",
  "sleutel": "ac-nutritional-kosher",
  "namen": {
   "nl": "Koosjer",
   "en": "Kosher",
   "da": "Kosher",
   "de": "Koscher",
   "el": "Kosher",
   "es": "Kosher",
   "fi": "Kosher",
   "fr": "Casher",
   "it": "Kosher",
   "no": "Kosher",
   "pl": "Koszerne",
   "pt": "Kosher",
   "sv": "Kosher"
  }
 },
 {
  "id": 2021,
  "groep": "voeding",
  "sleutel": "ac-nutritional-organic",
  "namen": {
   "nl": "Biologisch",
   "en": "Organic",
   "da": "Økologisk",
   "de": "Bio",
   "el": "Βιολογικό",
   "es": "Ecológico",
   "fi": "Luomu",
   "fr": "Biologique",
   "it": "Biologico",
   "no": "Økologisk",
   "pl": "Ekologiczne",
   "pt": "Biológico",
   "sv": "Ekologisk"
  }
 },
 {
  "id": 2022,
  "groep": "voeding",
  "sleutel": "ac-nutritional-fairtrade",
  "namen": {
   "nl": "Fairtrade",
   "en": "Fairtrade",
   "da": "Fairtrade",
   "de": "Fairtrade",
   "el": "Fairtrade",
   "es": "Comercio justo",
   "fi": "Reilu kauppa",
   "fr": "Commerce équitable",
   "it": "Commercio equo e solidale",
   "no": "Fairtrade",
   "pl": "Fairtrade",
   "pt": "Comércio justo",
   "sv": "Fairtrade"
  }
 },
 {
  "id": 2023,
  "groep": "voeding",
  "sleutel": "ac-nutritional-alcohol-free",
  "namen": {
   "nl": "Alcoholvrij",
   "en": "Alcohol-free",
   "da": "Alkoholfri",
   "de": "Alkoholfrei",
   "el": "Χωρίς αλκοόλ",
   "es": "Sin alcohol",
   "fi": "Alkoholiton",
   "fr": "Sans alcool",
   "it": "Analcolico",
   "no": "Alkoholfri",
   "pl": "Bezalkoholowe",
   "pt": "Sem álcool",
   "sv": "Alkoholfri"
  }
 },
 {
  "id": 2024,
  "groep": "voeding",
  "sleutel": "ac-nutritional-decaffeinated",
  "namen": {
   "nl": "Cafeïnevrij",
   "en": "Decaffeinated",
   "da": "Koffeinfri",
   "de": "Koffeinfrei",
   "el": "Χωρίς καφεΐνη",
   "es": "Sin cafeína",
   "fi": "Kofeiiniton",
   "fr": "Sans caféine",
   "it": "Senza caffeina",
   "no": "Koffeinfri",
   "pl": "Bezkofeinowe",
   "pt": "Descafeinado",
   "sv": "Koffeinfri"
  }
 },
 {
  "id": 2025,
  "groep": "voeding",
  "sleutel": "ac-nutritional-spicy",
  "namen": {
   "nl": "Pittig",
   "en": "Spicy",
   "da": "Stærk",
   "de": "Scharf",
   "el": "Πικάντικο",
   "es": "Picante",
   "fi": "Tulinen",
   "fr": "Épicé",
   "it": "Piccante",
   "no": "Sterk",
   "pl": "Ostre",
   "pt": "Picante",
   "sv": "Stark"
  }
 },
 {
  "id": 2026,
  "groep": "voeding",
  "sleutel": "ac-nutritional-extra-spicy",
  "namen": {
   "nl": "Extra pittig",
   "en": "Extra spicy",
   "da": "Ekstra stærk",
   "de": "Extra scharf",
   "el": "Πολύ πικάντικο",
   "es": "Muy picante",
   "fi": "Erittäin tulinen",
   "fr": "Très épicé",
   "it": "Molto piccante",
   "no": "Ekstra sterk",
   "pl": "Extra ostre",
   "pt": "Extra picante",
   "sv": "Extra stark"
  }
 },
 {
  "id": 2027,
  "groep": "voeding",
  "sleutel": "ac-nutritional-child-friendly",
  "namen": {
   "nl": "Kindvriendelijk",
   "en": "Child-friendly",
   "da": "Børnevenlig",
   "de": "Kinderfreundlich",
   "el": "Φιλικό προς τα παιδιά",
   "es": "Apto para niños",
   "fi": "Lapsiystävällinen",
   "fr": "Adapté aux enfants",
   "it": "Adatto ai bambini",
   "no": "Barnevennlig",
   "pl": "Przyjazne dzieciom",
   "pt": "Adequado para crianças",
   "sv": "Barnvänlig"
  }
 }
];
